<template>
  <div>
    <template v-if="selectedBot && selectedBot.type == 'nextcapital'">
      <new-classify-vue />
    </template>
    <template v-else>
      <traditional-classify-vue />
    </template>
  </div>
</template>

<script>
import NewClassifyVue from './NewClassify.vue'
import TraditionalClassifyVue from './TraditionalClassify.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    NewClassifyVue,
    TraditionalClassifyVue
  },
  computed: {
    ...mapGetters(['selectedBot'])
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/NonClassify/index.vue